import picture1 from "../assets/partners/picture1.png";
import picture2 from "../assets/partners/picture2.png";
import picture3 from "../assets/partners/picture3.png";
import picture4 from "../assets/partners/picture4.png";
import picture5 from "../assets/partners/picture5.png";
import picture6 from "../assets/partners/picture6.png";
import picture7 from "../assets/partners/picture7.png";
import picture8 from "../assets/partners/picture8.png";
import picture9 from "../assets/partners/picture9.png";
import picture10 from "../assets/partners/picture10.png";
import picture13 from "../assets/partners/picture13.png";
import picture14 from "../assets/partners/picture14.png";
import picture15 from "../assets/partners/picture15.png";
import picture16 from "../assets/partners/picture16.png";
import picture17 from "../assets/partners/picture17.png";
import picture18 from "../assets/partners/picture18.gif";
import picture19 from "../assets/partners/picture19.png";
import picture20 from "../assets/partners/picture20.png";
import picture21 from "../assets/partners/picture21.png";
import picture22 from "../assets/partners/picture22.png";
import picture23 from "../assets/partners/picture23.png";
import picture24 from "../assets/partners/picture24.png";
import picture25 from "../assets/partners/picture25.png";
import picture26 from "../assets/partners/picture26.png";
import picture27 from "../assets/partners/picture27.png";
import picture28 from "../assets/partners/picture28.png";
import picture29 from "../assets/partners/picture29.png";
import picture30 from "../assets/partners/picture30.png";
import picture31 from "../assets/partners/picture31.png";
import picture32 from "../assets/partners/picture32.png";
import picture33 from "../assets/partners/picture33.png";
import picture34 from "../assets/partners/picture34.png";
import picture35 from "../assets/partners/picture35.png";
import picture36 from "../assets/partners/picture36.png";
import picture37 from "../assets/partners/picture37.png";
import picture38 from "../assets/partners/picture38.png";
import picture39 from "../assets/partners/picture39.png";
import picture40 from "../assets/partners/picture40.png";
import picture41 from "../assets/partners/picture41.png";
import picture42 from "../assets/partners/picture42.png";
import picture43 from "../assets/partners/picture43.png";
import picture44 from "../assets/partners/picture44.png";
import picture45 from "../assets/partners/picture45.png";
import picture46 from "../assets/partners/picture46.png";
import picture47 from "../assets/partners/picture47.png";
import picture48 from "../assets/partners/picture48.png";
import picture49 from "../assets/partners/picture49.png";
import picture50 from "../assets/partners/picture50.png";
import picture51 from "../assets/partners/picture51.png";
import picture52 from "../assets/partners/picture52.png";
import picture53 from "../assets/partners/picture53.png";
import picture54 from "../assets/partners/picture54.png";
import picture55 from "../assets/partners/picture55.png";
import picture56 from "../assets/partners/picture56.png";
import picture57 from "../assets/partners/picture57.png";
import picture58 from "../assets/partners/picture58.png";
import picture59 from "../assets/partners/picture59.png";
import picture60 from "../assets/partners/picture60.png";
import picture61 from "../assets/partners/picture61.png";
import picture62 from "../assets/partners/picture62.jpg";
import picture63 from "../assets/partners/picture63.png";

let partnersHomePage = [
  {
    id: 1,
    name: "picture1",
    image: picture1,
  },
  {
    id: 3,
    name: "picture3",
    image: picture3,
  },
  {
    id: 4,
    name: "picture4",
    image: picture4,
  },
  {
    id: 5,
    name: "picture5",
    image: picture5,
  },
  {
    id: 6,
    name: "picture6",
    image: picture6,
  },
  {
    id: 7,
    name: "picture7",
    image: picture7,
  },
  {
    id: 8,
    name: "picture8",
    image: picture8,
  },
  {
    id: 9,
    name: "picture9",
    image: picture9,
  },
  {
    id: 13,
    name: "picture13",
    image: picture13,
  },
  {
    id: 14,
    name: "picture14",
    image: picture14,
  },
  {
    id: 15,
    name: "picture15",
    image: picture15,
  },
  {
    id: 16,
    name: "picture16",
    image: picture16,
  },
  {
    id: 18,
    name: "picture18",
    image: picture18,
  },
  {
    id: 19,
    name: "picture19",
    image: picture19,
  },
  {
    id: 21,
    name: "picture21",
    image: picture21,
  },
  {
    id: 24,
    name: "picture24",
    image: picture24,
  },
  {
    id: 26,
    name: "picture26",
    image: picture26,
  },
  {
    id: 37,
    name: "picture37",
    image: picture37,
  },
  {
    id: 42,
    name: "picture42",
    image: picture42,
  },
  {
    id: 47,
    name: "picture47",
    image: picture47,
  },
  {
    id: 49,
    name: "picture49",
    image: picture49,
  },
  {
    id: 59,
    name: "picture59",
    image: picture59,
  },
  {
    id: 60,
    name: "picture60",
    image: picture60,
  },
];

const partners = [
  {
    id: 1,
    name: "picture1",
    image: picture1,
  },
  {
    id: 2,
    name: "picture2",
    image: picture2,
  },
  {
    id: 3,
    name: "picture3",
    image: picture3,
  },
  {
    id: 4,
    name: "picture4",
    image: picture4,
  },
  {
    id: 5,
    name: "picture5",
    image: picture5,
  },
  {
    id: 6,
    name: "picture6",
    image: picture6,
  },
  {
    id: 7,
    name: "picture7",
    image: picture7,
  },
  {
    id: 8,
    name: "picture8",
    image: picture8,
  },
  {
    id: 9,
    name: "picture9",
    image: picture9,
  },
  {
    id: 10,
    name: "picture10",
    image: picture10,
  },
  {
    id: 13,
    name: "picture13",
    image: picture13,
  },
  {
    id: 14,
    name: "picture14",
    image: picture14,
  },
  {
    id: 15,
    name: "picture15",
    image: picture15,
  },
  {
    id: 16,
    name: "picture16",
    image: picture16,
  },
  {
    id: 17,
    name: "picture17",
    image: picture17,
  },
  {
    id: 18,
    name: "picture18",
    image: picture18,
  },
  {
    id: 19,
    name: "picture19",
    image: picture19,
  },
  {
    id: 20,
    name: "picture20",
    image: picture20,
  },
  {
    id: 21,
    name: "picture21",
    image: picture21,
  },
  {
    id: 22,
    name: "picture22",
    image: picture22,
  },
  {
    id: 23,
    name: "picture23",
    image: picture23,
  },
  {
    id: 24,
    name: "picture24",
    image: picture24,
  },
  {
    id: 25,
    name: "picture25",
    image: picture25,
  },
  {
    id: 26,
    name: "picture26",
    image: picture26,
  },
  {
    id: 27,
    name: "picture27",
    image: picture27,
  },
  {
    id: 28,
    name: "picture28",
    image: picture28,
  },
  {
    id: 29,
    name: "picture29",
    image: picture29,
  },
  {
    id: 30,
    name: "picture30",
    image: picture30,
  },
  {
    id: 31,
    name: "picture31",
    image: picture31,
  },
  {
    id: 32,
    name: "picture32",
    image: picture32,
  },
  {
    id: 33,
    name: "picture33",
    image: picture33,
  },
  {
    id: 34,
    name: "picture34",
    image: picture34,
  },
  {
    id: 35,
    name: "picture35",
    image: picture35,
  },
  {
    id: 36,
    name: "picture36",
    image: picture36,
  },
  {
    id: 37,
    name: "picture37",
    image: picture37,
  },
  {
    id: 38,
    name: "picture38",
    image: picture38,
  },
  {
    id: 39,
    name: "picture39",
    image: picture39,
  },
  {
    id: 40,
    name: "picture40",
    image: picture40,
  },
  {
    id: 41,
    name: "picture41",
    image: picture41,
  },
  {
    id: 42,
    name: "picture42",
    image: picture42,
  },
  {
    id: 43,
    name: "picture43",
    image: picture43,
  },
  {
    id: 44,
    name: "picture44",
    image: picture44,
  },
  {
    id: 45,
    name: "picture45",
    image: picture45,
  },
  {
    id: 46,
    name: "picture46",
    image: picture46,
  },
  {
    id: 47,
    name: "picture47",
    image: picture47,
  },
  {
    id: 48,
    name: "picture48",
    image: picture48,
  },
  {
    id: 49,
    name: "picture49",
    image: picture49,
  },
  {
    id: 50,
    name: "picture50",
    image: picture50,
  },
  {
    id: 51,
    name: "picture51",
    image: picture51,
  },
  {
    id: 52,
    name: "picture52",
    image: picture52,
  },
  {
    id: 53,
    name: "picture53",
    image: picture53,
  },
  {
    id: 54,
    name: "picture54",
    image: picture54,
  },
  {
    id: 55,
    name: "picture55",
    image: picture55,
  },
  {
    id: 56,
    name: "picture56",
    image: picture56,
  },
  {
    id: 57,
    name: "picture57",
    image: picture57,
  },
  {
    id: 58,
    name: "picture58",
    image: picture58,
  },
  {
    id: 59,
    name: "picture59",
    image: picture59,
  },
  {
    id: 60,
    name: "picture60",
    image: picture60,
  },
  {
    id: 61,
    name: "picture61",
    image: picture61,
  },
  {
    id: 62,
    name: "picture62",
    image: picture62,
  },
  {
    id: 63,
    name: "picture63",
    image: picture63,
  },
];

export { partnersHomePage, partners };
